import * as React from 'react';

const EnterIcon = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={20} height={20} viewBox='0 0 25 25' fill='none' {...props}>
		<path
			fill='#fff'
			d='M21.667 3.593h-1.562a.209.209 0 0 0-.209.209v13.49H7.24V15.39a.209.209 0 0 0-.339-.164l-3.695 2.917a.208.208 0 0 0 0 .328l3.695 2.916c.138.11.339.011.339-.163V19.27h12.969c.919 0 1.666-.747 1.666-1.666V3.802a.209.209 0 0 0-.208-.209Z'
		/>
	</svg>
);
export default EnterIcon;
